/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';

import './Footer.scss';
import Img from '../../atoms/Img/Img';
import logo from '../../../assets/images/grainger-logo-text.svg';
import { footerCopy } from '../../../content/main.json';
import { ClipPathSvgs } from './ClipPathSvgs';

const Footer = (props) => {
  const {
    social,
  } = props;

  return (
    <footer className="gr-footer">
      <div className="gr-footer__wrapper">
        <div className="gr-footer__logo-section">
          <a
            aria-label="Grainger home page"
            className="gr-footer__logo-link"
            href="/"
          >
            <Img
              alt="grainger"
              src={logo}
              className="gr-footer__logo"
            />
          </a>
        </div>

        <div className="gr-footer__main-content">
          <div className="gr-footer__column gr-footer__column--address">
            <h3 className="gr-footer__section-title">Registered office</h3>
            <address className="gr-footer__address">
              Citygate
              <br />
              St James&apos; Boulevard
              <br />
              Newcastle upon Tyne
              <br />
              NE1 4JE
            </address>
          </div>

          <div className="gr-footer__column gr-footer__column--links">
            <h3 className="gr-footer__section-title">Legal</h3>
            <ul className="gr-footer__links-list">
              {footerCopy.links.map((link) => (
                <li key={uuid()}>
                  <a
                    href={link.url}
                    className="gr-footer__link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {link.linkText}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="gr-footer__bottom-section">
          <div className="gr-footer__social-section">
            {social && (
              <div className="gr-footer__social-links">
                {social.map((link) => (
                  <a
                    key={link.icon}
                    className="gr-footer__social-link"
                    href={link.link}
                    aria-label={link.text}
                  >
                    <span className="sr-only">{link.text}</span>
                    <i
                      className={`icon icon-${link.icon}`}
                      aria-hidden="true"
                    />
                  </a>
                ))}
              </div>
            )}
          </div>

          <div className="gr-footer__info-section">
            <p className="gr-footer__grainger-info">
              {footerCopy.strapline}
            </p>
            <a
              href={`tel:${footerCopy.phoneNumber}`}
              className="gr-footer__phone-number"
            >
              {footerCopy.phone}
            </a>
            <div
              className="gr-footer__text"
              dangerouslySetInnerHTML={{ __html: footerCopy.info }}
            />
          </div>
        </div>
      </div>
      <ClipPathSvgs />
    </footer>
  );
};

Footer.propTypes = {
  social: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      link: PropTypes.string,
      text: PropTypes.string,
    }),
  ),
};

Footer.defaultProps = {
  social: null,
};

export default Footer;
